import { create } from 'zustand'

import type {
  AuthData,
  BusinessUnit,
  UserInfo
} from '../../types/session.types'
import type { UserPermissions } from '../../types/user-permissions.types'

interface SessionState {
  authData: AuthData
  businessUnit: BusinessUnit
  userInfo: UserInfo
  permissions: UserPermissions
  setAuthData: (data: AuthData) => void
  setBusinessUnit: (data: BusinessUnit) => void
  setUserInfo: (data: UserInfo) => void
  setPermissions: (data: UserPermissions) => void
  resetStore: () => void
}

const initialState = {
  authData: { accessToken: '', isExpired: false },
  businessUnit: {
    currentUnit: { id: 0, name: '', code: '', realmName: '' },
    units: []
  },
  userInfo: { username: '', email: '', name: '', id: '' },
  permissions: [] as UserPermissions
}

export const useSessionStore = create<SessionState>(set => ({
  ...initialState,
  setAuthData: data => set({ authData: data }),
  setBusinessUnit: data => set({ businessUnit: data }),
  setUserInfo: data => set({ userInfo: data }),
  setPermissions: data => set({ permissions: data }),
  resetStore: () => set(initialState)
}))

export const getSessionStoreState = () => useSessionStore.getState()
